import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserModel, ChangePasswordModel } from 'shared/definition';
import { PostOptions } from './generic-api.service';
import { SpinningService } from './spinning.service';
import { MessageService } from './message.service';
import { tap } from 'rxjs/operators';

const apiUrl = "api/currentUser";
@Injectable({
  providedIn: 'root'
})
export class CurrentUserApiService {

  constructor(private httpClient: HttpClient, private spinning: SpinningService, private messageService: MessageService) {

  }

  public get() {
    return this.httpClient.get<UserModel>(apiUrl);
  }

  public update(model: UserModel) {
    // options = {
    //   ...{
    //     notifyOnSuccess: true,
    //     showSpinning: true
    //   },
    //   ...options
    // }
    return this.spinning.startWith(this.httpClient.put(apiUrl, model)).pipe(
      tap(() => this.messageService.saveSuccess())
    )
  }

  public changePassword(model: ChangePasswordModel) {
    return this.spinning.startWith(this.httpClient.put(`${apiUrl}/password`, model)).pipe(
      tap(() => this.messageService.saveSuccess())
    )

  }

}
